import { LabelTypography } from '../../../../../ui/components/LabelTypography';
import { OrganizationsSelection } from '../../../../../ui/features/organizations/components/OrganizationsPanel/components/OrganizationsSelection';
import { OrganizationsSelectionAnonymous } from '../../../../../ui/features/organizations/components/OrganizationsPanel/components/OrganizationsSelectionAnonymous';
import { showOrganizationTreeDialog } from '../../../../../ui/features/organizations/components/OrganizationsTreeDialog';
import { showOrganizationTreeDialogAnonymous } from '../../../../../ui/features/organizations/components/OrganizationsTreeDialog/OrganizationsTreeDialogAnonymous';
import { toKebabCase } from '../../../../../utils';
import { buildGeneralTab, buildHiddenTab, buildStyleTab, buildValidateTab, showWidgetEditDialog, } from '@juvare/common-form-ui/WidgetEditDialog';
import { FormHelperErrorDescription } from '@juvare/common-form-ui/WidgetForm/Components';
import { defaultWidgetLabelProvider, getLabelAndValuePairs, getVisibleError, handleWidgetUpdate, joinLabels, makeNewConfigUnique, renderForm, validateCustom, } from '@juvare/common-form-ui/WidgetForm/Utils';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import CheckIcon from '@mui/icons-material/Check';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { Box, Button, Divider, FormControl, FormLabel, Typography } from '@mui/material';
import React from 'react';
const type = 'contactManagement.organizationSharing';
export const WidgetOrganizationSharing = (props) => {
    var _a, _b, _c;
    const getValue = () => props.getData();
    const value = getValue();
    const error = getVisibleError(props);
    const setValue = (newValue) => {
        props.setData(newValue);
        renderForm(props, { changed: true });
    };
    const showSelectAllChildren = props.config.showSelectAllChildren;
    const treeItemIds = [];
    // TODO update check if value is uuid, zod could be used
    if (value && Array.isArray(value)) {
        treeItemIds.push(...value);
    }
    return (React.createElement(FormControl, { error: !!error, disabled: props.config.disabled, fullWidth: true },
        props.config.label && (React.createElement(FormLabel, { sx: { marginBottom: 0.5 }, error: !!error }, props.config.label)),
        props.config.sharingOptions && props.config.sharingOptions.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'stretch', padding: '0 1px 0 1px' } }, (_a = props.config.sharingOptions) === null || _a === void 0 ? void 0 : _a.map((option, index) => (React.createElement(React.Fragment, { key: option.type },
                index > 0 && React.createElement(DividerWithLabel, { label: 'or' }),
                React.createElement(BigToggleButton, { icon: option.icon, label: option.label, selected: isSelected(value, option.type), onClick: () => {
                        var _a;
                        if (option.type) {
                            if (option.type === 'organizations') {
                                if (props.config.anonymous) {
                                    showOrganizationTreeDialogAnonymous({
                                        showSelectAllChildren,
                                        initialSelectedOrganizationIds: treeItemIds,
                                        multiSelect: true,
                                        onChange: setValue,
                                    });
                                }
                                else {
                                    showOrganizationTreeDialog({
                                        showSelectAllChildren,
                                        staticFilters: {
                                            visible: (_a = props.config.includeVisible) !== null && _a !== void 0 ? _a : undefined,
                                            permission: props.config.includeByMembership ? 'member' : undefined,
                                            orgPermissions: props.config.includeByOrgPermission,
                                        },
                                        initialSelectedOrganizationIds: treeItemIds,
                                        multiSelect: true,
                                        onChange: setValue,
                                    });
                                }
                            }
                            else {
                                if (value !== option.type) {
                                    setValue(option.type);
                                }
                            }
                        }
                        else {
                            setValue(undefined);
                        }
                    } }))))))),
        (!props.config.sharingOptions || props.config.sharingOptions.length === 0 || Array.isArray(value)) && (React.createElement(Box, { pt: props.config.sharingOptions && props.config.sharingOptions.length > 0 ? 4 : 0 }, props.config.anonymous ? (React.createElement(OrganizationsSelectionAnonymous, { showSelectAllChildren: showSelectAllChildren, organizationIds: treeItemIds, renderOrganization: (organization) => (React.createElement(LabelTypography, { sx: { flexGrow: 1 }, color: organization.disabled ? 'textSecondary' : 'initial', "aria-disabled": organization.disabled }, organization.name)), hideValidationMessage: true, onChangeOrganizationIds: setValue, addLabel: props.config.addLabel })) : (React.createElement(OrganizationsSelection, { showSelectAllChildren: showSelectAllChildren, organizationIds: treeItemIds, staticDialogFilters: {
                visible: (_b = props.config.includeVisible) !== null && _b !== void 0 ? _b : false,
                permission: props.config.includeByMembership ? 'member' : undefined,
                orgPermissions: props.config.includeByOrgPermission,
            }, renderOrganization: (organization) => (React.createElement(LabelTypography, { sx: { flexGrow: 1 }, color: organization.disabled ? 'textSecondary' : 'initial', "aria-disabled": organization.disabled }, organization.name)), hideValidationMessage: true, onChangeOrganizationIds: setValue, addLabel: props.config.addLabel })))),
        React.createElement(FormHelperErrorDescription, { error: error }),
        ((_c = props.config.sharingOptions) !== null && _c !== void 0 ? _c : [])
            .filter((option) => isSelected(value, option.type) && option.description)
            .map((option) => (React.createElement(Typography, { key: option.type, variant: 'body2', sx: { pt: 4, color: (theme) => theme.palette.grey['700'] } }, option.description)))));
};
export const WidgetOrganizationSharingEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: 'Public Or Specific Organization',
        }, buildGeneralTab(props, {
            key: true,
            labelOptional: true,
            disabled: true,
            children: [
                {
                    type: 'form.checkbox',
                    key: 'includeVisible',
                    label: 'Include Visible',
                    tooltip: { text: 'Organizations with the visible flag set to true' },
                },
                {
                    type: 'form.checkbox',
                    key: 'includeByMembership',
                    label: 'Include By Membership',
                    tooltip: { text: 'Organizations where currently logged in user is a member of' },
                },
                {
                    type: 'form.multiSelect',
                    key: 'includeByOrgPermission',
                    label: 'Include By Org Permission',
                    tooltip: { text: 'Organization where currently logged in user has any of the selected permissions' },
                    valueProvider: { type: 'contactManagement.orgPermission' },
                },
                { type: 'form.checkbox', key: 'disableNotVisible', label: 'Disable Not Visible' },
                { type: 'form.checkbox', key: 'showSelectAllChildren', label: 'Show Select All Children' },
            ],
            onSubmit: (data) => {
                var _a;
                if (((_a = data.includeByOrgPermission) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    delete data.includeByOrgPermission;
                }
                return data;
            },
        }), {
            label: 'Sharing Options',
            children: [
                {
                    type: 'form.dataGrid',
                    key: 'sharingOptions',
                    emptyAsNull: true,
                    reorder: true,
                    children: [
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'type',
                                    label: 'Type',
                                    description: 'Use type "organizations" to show organization picker. Use empty type for "no sharing" option',
                                    emptyAsNull: true,
                                    validate: {
                                        uniqueInGrid: true,
                                    },
                                },
                            ],
                            style: {
                                width: 300,
                            },
                        },
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.select',
                                    key: 'icon',
                                    label: 'Icon',
                                    values: [
                                        { value: 'material-group-add', label: 'Group Add' },
                                        { value: 'material-groups', label: 'Groups' },
                                        { value: 'material-person', label: 'Person' },
                                    ],
                                },
                                {
                                    type: 'form.text',
                                    key: 'label',
                                    label: 'Label',
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    type: 'form.text',
                                    key: 'description',
                                    label: 'Description',
                                    multiline: true,
                                    rows: 3,
                                },
                            ],
                        },
                    ],
                },
            ],
        }, buildValidateTab(props, {
            required: true,
            children: [
                {
                    type: 'form.number',
                    key: 'validate.minOrganizationsLength',
                    label: 'Min Number of Organizations',
                },
                {
                    type: 'form.number',
                    key: 'validate.maxOrganizationsLength',
                    label: 'Max Number of Organizations',
                },
            ],
        }), buildHiddenTab(props), buildStyleTab(props)) }),
        React.createElement(WidgetOrganizationSharing, Object.assign({}, props))));
};
export const widgetOrganizationSharing = {
    type,
    validate: (props) => {
        var _a, _b, _c, _d, _e;
        const value = props.getData();
        if ((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required) {
            if (value == null) {
                return 'Option must be selected';
            }
        }
        if (((_b = props.config.validate) === null || _b === void 0 ? void 0 : _b.minOrganizationsLength) != null) {
            if (props.config.validate.minOrganizationsLength === 1) {
                if (Array.isArray(value) && value.length === 0) {
                    return 'At least one organization must be selected';
                }
            }
            else if (((_c = props.config.validate) === null || _c === void 0 ? void 0 : _c.minOrganizationsLength) > 1) {
                if (Array.isArray(value) && value.length < props.config.validate.minOrganizationsLength) {
                    return 'At least ' + props.config.validate.minOrganizationsLength + ' organizations must be selected';
                }
            }
        }
        if (((_d = props.config.validate) === null || _d === void 0 ? void 0 : _d.maxOrganizationsLength) != null) {
            if (props.config.validate.maxOrganizationsLength === 1) {
                if (Array.isArray(value) && value.length > 1) {
                    return 'No more than one organization must be selected';
                }
            }
            else if (((_e = props.config.validate) === null || _e === void 0 ? void 0 : _e.maxOrganizationsLength) > 1) {
                if (Array.isArray(value) && value.length > props.config.validate.maxOrganizationsLength) {
                    return 'A maximum of ' + props.config.validate.maxOrganizationsLength + ' organizations must be selected';
                }
            }
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    getLabelValueAsTextPairs: (props, labelPrefix) => {
        var _a, _b, _c;
        const value = props.getData();
        if (value != null) {
            let string;
            if (!Array.isArray(value)) {
                string = (_c = (_b = (_a = props.config.sharingOptions) === null || _a === void 0 ? void 0 : _a.find((option) => option.type === value)) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : value;
            }
            else {
                // is this good enough?
                string =
                    value.length === 0
                        ? 'No organizations selected'
                        : value.length + ' organization' + (value.length > 0 ? 's' : '') + ' selected';
            }
            return getLabelAndValuePairs(joinLabels(labelPrefix, props.config.label), string);
        }
        else {
            return [];
        }
    },
    component: WidgetOrganizationSharing,
    icon: React.createElement(CheckIcon, { fontSize: 'small' }),
    editorComponent: WidgetOrganizationSharingEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'sharing' }),
};
function isSelected(value, type) {
    if (type) {
        if (type === 'organizations') {
            return Array.isArray(value);
        }
        else {
            return value === type;
        }
    }
    else {
        return value == null;
    }
}
const BigToggleButton = ({ icon, label, selected, onClick, }) => (React.createElement(Button, { variant: 'outlined', sx: {
        flex: '1 1 0px',
        flexDirection: 'column',
        p: 2,
        textTransform: 'none',
        outline: (theme) => (selected ? '2.5px solid ' + theme.palette.primary.main : 'none'),
        outlineOffset: -1,
    }, onClick: onClick, "data-test": `big-toggle-button-${toKebabCase(label)}`, "aria-pressed": selected },
    icon && React.createElement(BigToggleButtonIcon, { icon: icon }),
    React.createElement(Typography, { variant: 'subtitle2', sx: { pt: 2 } }, label)));
const BigToggleButtonIcon = ({ icon }) => (React.createElement(Box, { sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: themeColors.accent.blue.subtlest,
        width: 40,
        height: 40,
        borderRadius: 20,
    } },
    icon === 'material-group-add' && React.createElement(GroupAddOutlinedIcon, null),
    icon === 'material-groups' && React.createElement(GroupsOutlinedIcon, null),
    icon === 'material-person' && React.createElement(PersonOutlinedIcon, null)));
const DividerWithLabel = ({ label }) => (React.createElement(Divider, { orientation: 'vertical', flexItem: true },
    React.createElement(Typography, { variant: 'caption', sx: { color: themeColors.border.boldest } }, label)));
